var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSheetIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_306_6398",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_306_6398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6719 7.08613V22.9299C20.6719 23.783 19.9828 24.4721 19.1297 24.4721H4.87031C4.01719 24.4721 3.32812 23.783 3.32812 22.9299V2.07051C3.32812 1.21738 4.01719 0.52832 4.87031 0.52832H14.1141L20.6719 7.08613Z",
    fill: "#23A566"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7919 12.4482H8.20752C7.93564 12.4482 7.71533 12.6686 7.71533 12.9404V19.5451C7.71533 19.817 7.93564 20.0373 8.20752 20.0373H15.7966C16.0685 20.0373 16.2888 19.817 16.2888 19.5451V12.9451C16.2841 12.6732 16.0638 12.4482 15.7919 12.4482ZM8.69971 15.6171H11.5075V16.8686H8.69971L8.69971 15.6171ZM12.4922 15.6171H15.3V16.8686H12.4922V15.6171ZM15.3 14.6327H12.4922V13.4374H15.3V14.6327ZM11.5075 13.4374V14.6327H8.69971V13.4374H11.5075ZM8.69971 17.8575H11.5075V19.0529H8.69971V17.8575ZM12.4922 19.0529V17.8575H15.3V19.0529H12.4922Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.19,
    d: "M14.9956 6.84688L20.6722 11.4453V7.12813L17.4519 5.25781L14.9956 6.84688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6716 7.08613H15.656C14.8028 7.08613 14.1138 6.39707 14.1138 5.54395V0.52832L20.6716 7.08613Z",
    fill: "#8ED1B1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetIcon);
export default __webpack_public_path__ + "static/media/sheet-icon.abbb27bd6020bb9882d7689a211080b8.svg";
export { ForwardRef as ReactComponent };